import React from "react";
import { Checkbox } from "@fluentui/react-northstar";
const IsTPE = (props) => {
  return (
    <>
      <Checkbox
        className="child-title-call-flow no-margin-top"
       
        toggle
        disabled = {!props.isNewCallFlow}
        checked={props.isTPE}
        onChange={(e, data) => {
          props.getData(data.checked);
        }}
      />
    </>
  );
};
export default IsTPE;
